<template>
  <div class="help-center-footer__component">
    <HelpCenterFooterGroup
      v-for="menuGroup in props.menu"
      :key="menuGroup.id"
      :data-directus-hide="menuGroup.hide_lower_or_equal"
      :menu-group="menuGroup"
      class="help-center-footer__group"
    />
    <HelpCenterFooterNotice />
  </div>
</template>

<script setup>
import HelpCenterFooterGroup from 'help-center/components/HelpCenterFooterGroup'
import HelpCenterFooterNotice from 'help-center/components/HelpCenterFooterNotice'

const props = defineProps({
  menu: {
    type: Array,
    required: true
  }
})
</script>

<style lang="scss">
@import 'help-center/mixins';

.help-center-footer {
  &__component {
    gap: 80px;
    display: flex;
    justify-content: center;

    padding: 60px 0 20px;
    border-top: 1px solid var(--help-center-border);
  }

  &__group {
    @include help-center-hide-by-directus-attr;
  }
}
</style>
